module.exports = __webpack_public_path__ + "static/media/social-linkedin.082eb5ac.png";